<template>
  <v-container pa-0 py-2>

    <v-row no-gutters>
      <v-col cols="12">
        <v-row no-gutters>
          <v-list-item>
            <v-list-item-avatar>
              <v-switch :ripple="false" v-model="bid.repeat" readonly>

              </v-switch>
            </v-list-item-avatar>
            <v-list-item-content v-if="bid.repeat">
              <v-list-item-title :class="`title ${ bid.bid ? 'primary--text' : ''}`">
                {{ $language.addJob['Ongoing Job'] }}
              </v-list-item-title>
              <v-list-item-subtitle class="subtitle  grey--text">
                {{ $language.addJob['Set a work schedule'] }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content v-else>
              <v-list-item-title :class="`title `">
                {{ $language.addJob['One-time Job'] }}
              </v-list-item-title>
              <v-list-item-subtitle class="subtitle  grey--text">
                {{ $language.addJob['This job only happens once'] }}
              </v-list-item-subtitle>
            </v-list-item-content>

          </v-list-item>
        </v-row>
      </v-col>
      <!-- CONRTACT DATES -->
      <v-col cols="12" class="pt-4">
        <v-row no-gutters justify="start" align="start">
          <v-col :cols="bid.repeat?8:12" class="pt-2">
            <v-list-item>
              <v-list-item-content class="mb-0 pb-0">
                <v-menu ref="menu" v-model="menu1" :close-on-content-click="true" :return-value.sync="date" transition="scale-transition" offset-y top min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field hide-details outlined dense v-model="bid.startDate" :label="$language.addJob['Start Date']" readonly v-bind="attrs" v-on="on" :rules="requiredRule">
                      <template v-slot:prepend-inner>
                        <v-icon class="pr-2">event</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="bid.startDate" no-title scrollable :min="nowDate">
                  </v-date-picker>
                </v-menu>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12">
            <v-row no-gutters justify="start" align="center">
              <v-col :cols="bid.repeat?8:12">
                <v-list-item class="pt-2">
                  <v-list-item-content>
                    <v-list-item-title class="title">
                      Start:
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <vue-timepicker format="h:mm A" v-model="bid.startTime" @change="checkTime()" minute-interval="15" :input-class="$vuetify.theme.dark?'dark':''" drop-direction="up">
                      <template v-slot:dropdownButton>&#x02263;</template>
                    </vue-timepicker>
                  </v-list-item-action>
                </v-list-item>
              </v-col>

              <v-col  :cols="bid.repeat?8:12">
                <v-list-item class="pt-2">
                  <v-list-item-content>
                    <v-list-item-title class="title">
                      End:
                    </v-list-item-title>
                  </v-list-item-content>
                  <vue-timepicker format="h:mm A" v-model="bid.endTime" @change="checkTime()" minute-interval="15" :input-class="$vuetify.theme.dark?'dark':''" drop-direction="up">
                    <template v-slot:dropdownButton>&#x02263;</template>
                  </vue-timepicker>
                </v-list-item>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" v-if="bid.repeat">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class=" mb-2">
              {{$language.addJob[bid.occ.type]}}
              Repeats Every
            </v-list-item-title>
            <v-row no-gutters>
              <v-col cols="2" sm="2" class="pr-1">
                <v-text-field class="centered-input" outlined dense v-model="bid.occ.interval" hide-details></v-text-field>
              </v-col>
              <v-col cols="10" sm="5" :class="$vuetify.breakpoint.smAndUp?'px-1':'pl-1'">
                 <v-menu ref="menu5" v-model="menu5" :close-on-content-click="true" transition="scale-transition" offset-y min-width="290px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field hide-details outlined dense :value="$language.addJob[bid.occ.type]"  readonly v-bind="attrs" v-on="on" >

                              <template v-slot:append>
                                <v-icon class="pr-2">mdi-menu-down</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-list>
                              <v-list-item @click="()=>{bid.occ.type = 'Days'}">
                                <v-list-item-content>
                                  <v-list-item-title class="title">
                                    {{$language.addJob['repeatTypeCustomText'][0]}}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-list-item @click="()=>{bid.occ.type = 'Weeks'}">
                                <v-list-item-content>
                                  <v-list-item-title class="title">
                                    {{$language.addJob['repeatTypeCustomText'][1]}}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-list-item @click="()=>{bid.occ.type = 'Months'}">
                                <v-list-item-content>
                                  <v-list-item-title class="title">
                                    {{$language.addJob['repeatTypeCustomText'][2]}}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-list-item @click="()=>{bid.occ.type = 'Years'}">
                                <v-list-item-content>
                                  <v-list-item-title class="title">
                                    {{$language.addJob['repeatTypeCustomText'][3]}}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                          </v-list>
                        </v-menu>
                <!-- <v-select outlined dense :items="$language.addJob['repeatTypeCustom']" hide-details v-model="bid.occ.type"></v-select> -->
              </v-col>
              <v-col cols="12" sm="5" :class="$vuetify.breakpoint.smAndUp?'px-1 pl-1':'pt-4'">
                <v-menu ref="menu" v-model="menu3" :close-on-content-click="true" :return-value.sync="date" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field hide-details outlined dense v-model="bid.contractEndDate" :label="$language.addJob['Contract End Date']" readonly v-bind="attrs" v-on="on" :rules="requiredRule">
                      <template v-slot:prepend-inner>
                        <v-icon>event</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="bid.contractEndDate" no-title scrollable :min="bid.startDate">
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" v-if="bid.occ.type==='Weeks'">
                <v-item-group v-if="(bid.occ||{}).type==='Weeks'" v-model="bid.dayToggle" multiple class="pt-4  pb-4 d-flex justify-space-between" :key="index">
                  <v-item v-slot:default="{ active, toggle }">
                    <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" @click="toggle" :color="active?'primary':''">S</v-chip>
                  </v-item>
                  <v-item v-slot:default="{ active, toggle }">
                    <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" @click="toggle" :color="active?'primary':''">M</v-chip>
                  </v-item>
                  <v-item v-slot:default="{ active, toggle }">
                    <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" @click="toggle" :color="active?'primary':''">T</v-chip>
                  </v-item>
                  <v-item v-slot:default="{ active, toggle }">
                    <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" @click="toggle" :color="active?'primary':''">W</v-chip>
                  </v-item>
                  <v-item v-slot:default="{ active, toggle }">
                    <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" @click="toggle" :color="active?'primary':''">T</v-chip>
                  </v-item>
                  <v-item v-slot:default="{ active, toggle }">
                    <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" @click="toggle" :color="active?'primary':''">F</v-chip>
                  </v-item>
                  <v-item v-slot:default="{ active, toggle }">
                    <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" @click="toggle" :color="active?'primary':''">S</v-chip>
                  </v-item>
                </v-item-group>
              </v-col>
              <v-col cols="12" v-if="bid.occ.type==='Months'" class="pt-4" >
                <v-item-group v-model="monthToggle">
                  <v-item v-slot:default="{ active, toggle }">
                    <v-chip rounded class="mr-2 px-6" @click="toggle" :color="active?'primary':''">{{$language.addJob['day']}} {{dayOfMonth}} {{$language.addJob['of the month']}}.</v-chip>
                  </v-item>
                  <v-item v-slot:default="{ active, toggle }" class="mt-2">
                    <v-chip rounded class="mr-2 px-6" @click="toggle" :color="active?'primary':''">{{nth(bid.startDate)}} {{dayOfWeek(bid.startDate)}} {{$language.addJob['of the month']}}.</v-chip>
                  </v-item>
                </v-item-group>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
import { RRule } from 'rrule'
import VueTimepicker from 'vue2-timepicker'

const fb = require('@/services/firebaseConfig.js')
export default {
  props: ['editJob', 'isHefe', 'summaryView', 'status', 'hasStarted', 'publicView'],
  components: {
    VueTimepicker
  },
  data () {
    return {
      loading: false,
      dialog: '',
      job: {
        public: {
          bid: true,
          pictures: [],
          public: true,
          status: 'Draft',
          category: '',
          title: '',
          dayToggle: [],

          jobDesc: '',
          rateType: null,
          days: null,
          workers: 1,
          hours: null,
          rate: 10,
          fixedCost: null,
          startDate: new Date(moment()).toISOString().slice(0, 10),
          endDate: new Date(moment()).toISOString().slice(0, 10),
          contractEndDate: new Date(moment().add(1, 'month')).toISOString().slice(0, 10),
          startTime: {
            h: moment().format('h'),
            mm: '00',
            A: moment().format('A') },
          endTime: {
            h: moment().add(60, 'minutes').format('h'),
            mm: '00',
            A: moment().add(60, 'minutes').format('A') },

          repeat: false,
          occ: {
            interval: 1,
            type: 'Weeks',
            color: 'primary'
          }
        },
        mlmReferral: []
      },
      address: '',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu3: false,
      menu5: false,
      requiredRule: [
        (v) => (v && v.length < 100) || 'Required field'
      ],

      nowDate: new Date(moment().subtract(1, 'days')).toISOString().slice(0, 10),
      index: 0,
      showEndDate: false,
      monthToggle: 0,
      colors: ['primary', 'blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
      bid: {
        startTime: {
          h: moment().format('h'),
          mm: '00',
          A: moment().format('A') },
        endTime: {
          h: moment().add(60, 'minutes').format('h'),
          mm: '00',
          A: moment().add(60, 'minutes').format('A') },
        startDate: new Date(moment()).toISOString().slice(0, 10),
        endDate: new Date(moment()).toISOString().slice(0, 10),
        contractEndDate: new Date(moment().add(1, 'month')).toISOString().slice(0, 10),
        days: null,
        workers: 1,
        hours: null,
        rate: 10,
        fixedCost: null,
        bid: true
      }
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'categories']),
    timeFromNow () {
      return moment(`${this.bid.startDate}T${(this.bid.startTime || {}).h}.${(this.bid.startTime || {}).mm}${(this.bid.startTime || {}).A}`, ['YYYY-MM-DD HH.mm a'])
        .fromNow()
    },
    weekOfMonth () {
      var a = moment(this.bid.startDate)
      var c = Math.ceil(a.date() / 7)
      return c
    },
    dayOfMonth () {
      var a = moment(this.bid.startDate)
      var c = a.date()
      return c
    },
    compoundProperty () {
      return [(this.bid || {}).startDate, (this.bid || {}).endDate, (this.bid || {}).endTime, (this.bid || {}).endDate, (this.bid || {}).contractEndDate, (this.bid || {}).dayToggle, (this.bid || {}).monthToggle, ((this.bid || {}).occ || {}).type, ((this.bid || {}).occ || {}).interval].join()
    }

  },
  methods: {
    async get () {
      this.setSchedule().then(result => {
        // console.log(result)
      })
    },
    async setSchedule () {
      var rule, startTime, endTime, eachOccMin
      startTime = moment(`${this.bid.startTime.h}:${this.bid.startTime.mm} ${this.bid.startTime.A}`, ['h:mm A'])
      endTime = moment(`${this.bid.endTime.h}:${this.bid.endTime.mm} ${this.bid.endTime.A}`, ['h:mm A'])
      var dtstart = new Date(Date.UTC(moment(this.bid.startDate).year(), moment(this.bid.startDate).month(), moment(this.bid.startDate).date(), moment(startTime).hours(), moment(startTime).minutes()))
      var until = new Date(Date.UTC(moment(this.bid.contractEndDate).year(), moment(this.bid.contractEndDate).month(), moment(this.bid.contractEndDate).date() + 1))
      var untilNoRep = new Date(Date.UTC(moment(this.bid.startDate).year(), moment(this.bid.startDate).month(), moment(this.bid.startDate).date() + 1))
      eachOccMin = moment(`${endTime}:00`).diff(moment(`${startTime}:00`), 'minutes')
      switch (this.bid.repeat) {
        case false:
          this.bid.occ.interval = 1
          rule = new RRule({
            interval: parseInt(this.bid.occ.interval),
            dtstart: dtstart,
            until: untilNoRep
          })
          this.bid.contractEndDate = untilNoRep
          // console.log('finish non-repeat')
          break
        case true:
          var freq
          switch (this.bid.occ.type) {
            case 'Days':
              freq = RRule.DAILY

              rule = new RRule({
                freq: freq,
                interval: parseInt(this.bid.occ.interval),
                dtstart: dtstart,
                until: until
              })
              // console.log('finish daily-repeat')

              break
            case 'Weeks':
              var tog = this.bid.dayToggle.map(k => {
                switch (k) {
                  case 0:
                    return RRule.SU
                  case 1:
                    return RRule.MO
                  case 2:
                    return RRule.TU
                  case 3:
                    return RRule.WE
                  case 4:
                    return RRule.TH
                  case 5:
                    return RRule.FR
                  case 6:
                    return RRule.SA
                  default:
                    break
                }
              })
              freq = RRule.WEEKLY
              rule = new RRule({
                freq: freq,
                byweekday: tog,
                wkst: RRule.SU,
                interval: parseInt(this.bid.occ.interval),
                dtstart: dtstart,
                until: until
              })
              // console.log('finish weekly-repeat')
              break
            case 'Months':
              freq = RRule.MONTHLY

              if (this.monthToggle === 0) {
                rule = new RRule({
                  freq: freq,
                  interval: parseInt(this.bid.occ.interval),
                  bymonthday: this.dayOfMonth,
                  dtstart: dtstart,
                  until: until
                })
              } else {
                var dow
                switch (moment(this.bid.startDate).day()) {
                  case 1:
                    dow = [RRule.MO]
                    break
                  case 2:
                    dow = [RRule.TU]
                    break
                  case 3:
                    dow = [RRule.WE]
                    break
                  case 4:
                    dow = [RRule.TH]
                    break
                  case 5:
                    dow = [RRule.FR]
                    break
                  case 6:
                    dow = [RRule.SA]
                    break
                  case 0:
                    dow = [RRule.SU]
                    break
                  default:
                    break
                }

                rule = new RRule({
                  freq: freq,
                  interval: parseInt(this.bid.occ.interval),
                  bysetpos: parseInt(this.weekOfMonth),
                  byweekday: dow,
                  dtstart: dtstart,
                  until: until
                })
              }
              // console.log('finish monthly-repeat')

              break
            case 'Years':
              freq = RRule.YEARLY
              rule = new RRule({
                freq: freq,
                interval: parseInt(this.bid.occ.interval),
                dtstart: dtstart,
                until: until
              })
              // console.log('finish yearly-repeat')

              break
            default:
              break
          }
          break
        default:
          break
      }
      var occList = rule.all()

      occList = occList.map(k => {
        return moment(k).set({ h: moment(occList[0]).hour(), m: moment(occList[0]).minute() })
      })

      var events = []
      occList.map(k => {
        const timeOffset = (new Date()).getTimezoneOffset()
        k = moment(k).add(timeOffset, 'minutes')
        events.push({
          name: this.bid.title,
          start: new Date(k),
          end: new Date(moment(k).add(eachOccMin, 'minutes')),
          timed: true
        })
      })

      this.bid.schedule = events
      this.bid.hours = parseFloat(eachOccMin / 60).toFixed(2)
      this.bid.scheduleText = rule.toText()
      this.events = []
      this.events = events
      return events
    },

    isRateTypeSelected (option) {
      // This could have been done with an object with text and value, filter by the value but show the text. I wanted to try doing it this way.
      let original = ['Hourly', 'Fixed']
      return original.indexOf(option) === this.$language.addJob['rateType'].indexOf(this.bid.rateType)
    },

    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    changeColor (color) {
      var updates = {}
      this.bid.occ.color = color
      if (this.bid.schedule) {
        Object.keys(this.bid.schedule).map(k => {
          this.bid.schedule[k].color = color
        })
        updates[`/user/${this.currentUser.uid}/jobs/${this.bid._key}/schedule`] = this.bid.schedule
        updates[`/jobs/${this.bid._key}/public/schedule`] = this.bid.schedule
        updates[`/jobs/${this.bid._key}/public/occ/color`] = color
        fb.database.ref().update(updates)
      }
    },
    dayOfWeek (val) {
      if (!val) {
        return '-'
      }
      switch (moment(val).day()) {
        case 1:
          return this.$language.addJob['Monday']
        case 2:
          return this.$language.addJob['Tuesday']
        case 3:
          return this.$language.addJob['Wednesday']
        case 4:
          return this.$language.addJob['Thursday']
        case 5:
          return this.$language.addJob['Friday']
        case 6:
          return this.$language.addJob['Saturday']
        case 0:
          return this.$language.addJob['Sunday']
        default:
          break
      }
      return moment(val).day()
    },
    nth (val) {
      if (!val) {
        return '-'
      }
      switch (Math.ceil(moment(val).date() / 7)) {
        case 1:
          return this.$language.addJob['1st']
        case 2:
          return this.$language.addJob['2nd']
        case 3:
          return this.$language.addJob['3rd']
        case 4:
          return this.$language.addJob['4th']
        case 5:
          return this.$language.addJob['5th']
        default:
          break
      }
      return moment(val).day()
    },
    checkTime () {
      if (((this.bid || {}).startDate || false) && ((this.bid || {}).startTime || false)) {
        var start = moment(`${this.bid.startDate} ${this.bid.startTime.h}:${this.bid.startTime.mm} ${this.bid.startTime.A}`, ['YYYY-MM-DD HH.mm a'])
        var end = moment(`${this.bid.startDate} ${this.bid.endTime.h}:${this.bid.endTime.mm} ${this.bid.endTime.A}`, ['YYYY-MM-DD HH.mm a'])
        if (start >= end) {
          var newEnd = moment(`${this.bid.startDate} ${this.bid.startTime.h}:${this.bid.startTime.mm} ${this.bid.startTime.A}`, ['YYYY-MM-DD HH.mm a']).add(1, 'hour')
          this.bid.endTime = {
            h: newEnd.format('h'),
            mm: newEnd.format('mm'),
            A: newEnd.format('A')
          }
          this.bid.hours = (newEnd.diff(start, 'minutes') / 60)
        } else {
          this.bid.hours = (end.diff(start, 'minutes') / 60)
        }
      }
      this.setSchedule()
    }

  },
  watch: {

    editJob () {
      this.$nextTick(() => {
        this.bid.repeat = this.editJob.repeat
        this.dayToggle = this.bid.dayToggle ? this.bid.dayToggle : []
        this.index += this.index
      })
    },

    'repeat': function (val) {
      if (val === 'Custom...' || val === 'Personalizado...') {
        this.customRepeatDialog = true
        this.showEndDate = false
        this.bid.endDate = this.bid.startDate
      }
      if (val === this.$language.addJob['Does not repeat']) {
        this.showEndDate = false
      } else {
        this.showEndDate = true
      }
      this.$nextTick(() => {
        this.bid.contractEndDate = new Date(this.bid.contractEndDate).toISOString().slice(0, 10)
      })
    },
    'compoundProperty': function () {
      // var start = moment(`${this.bid.startDate}T${moment(`${this.bid.startTime.h}:${this.bid.startTime.mm} ${this.bid.startTime.A}`, ['h:mm A']).format('HH:mm')}:00`)
      // var end = moment(`${this.bid.endDate}T${moment(`${this.bid.endTime.h}:${this.bid.endTime.mm} ${this.bid.endTime.A}`, ['h:mm A']).format('HH:mm')}:00`)
      // this.bid.endDate = start.diff(end, 'minutes') > 0 ? this.bid.startDate : this.bid.endDate

      // this.bid.contractEndDate = moment(`${this.bid.contractEndDate}`).diff(moment(`${this.bid.startDate}`), 'minutes') < 0 ? new Date(moment(this.bid.endDate).add(1, 'month')).toISOString().slice(0, 10) : this.bid.contractEndDate
      // if (this.bid === this.$language.addJob['Custom...']) {
      //   this.bid.endDate = this.bid.startDate
      // }
      this.setSchedule()
    },
    'bid.startDate': function () {
      this.bid.endDate = this.bid.startDate
    },
    dayToggle () {
      this.setSchedule()
    },
    monthToggle () {
      this.setSchedule()
    },
    'bid.occ.type': function () {
      this.setSchedule()
    },
    'bid.occ.interval': function () {
      this.setSchedule()
    }
  },
  mounted: function () {
    this.bid = this.editJob
  },
  destroyed: function () {

  },
  filters: {

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    },
    formatTime (val) {
      if (!val) {
        return '-'
      }
      return moment(val, ['HH.mm']).format('hh:mm a')
    }
  }
}
</script>

<style scoped>
.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 2px solid #bdbdbd !important;
  border-radius: 5px;
  padding-left: 10px !important;
}

.theme--light.v-text-field--outline > .v-input__control > .v-input__slot:hover {
  border: 2px solid #bdbdbd !important;
}

/*.croppa-container {
  width: calc(100vw - 40px);
  max-width: 840px !important;
  height: 200px;
  margin: 0 auto;
  display: block;
}*/

.no-padding-hint > .v-input__control > .v-text-field__details {
  padding: 0px !important;
  margin: 0px !important;
}

.scrollable {
  overflow-y: auto;
}

.custom-input {
  border: 0.5px solid;
  border-color: grey;
}
.active {
  border: 0.5px solid;
  border-color: #ff5722;
}
.centered-input input {
  text-align: end;
}
</style>

// TIME PICKER
<style>
.vue__time-picker {
  display: inline-block;
  position: relative;
  font-size: 1em;
  width: 7em;

  font-family: sans-serif;
  vertical-align: middle;
}
.vue__time-picker * {
  box-sizing: border-box;
}
.vue__time-picker input.display-time {
  border: 1px solid grey;
  border-radius: 5px;
  width: 7em;
  height: 40px;
  padding: 0.3em 0.5em;
  font-size: 1em;
}
.dark {
  color: white;
}
.vue__time-picker input.has-custom-icon {
  padding-left: 2em;
}
.vue__time-picker input.display-time.invalid:not(.skip-error-style) {
  border-color: #ff5722;
  outline-color: #ff5722;
}
.vue__time-picker input.display-time:disabled,
.vue__time-picker input.display-time.disabled {
  color: #d2d2d2;
}
.vue__time-picker .controls {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 3;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: stretch;
  /* Prevent browser focusing on the controls layer */
  pointer-events: none;
}
.vue__time-picker .controls > * {
  cursor: pointer;

  width: auto;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding: 0 0.35em;
  color: #d2d2d2;
  line-height: 100%;
  font-style: normal;
  /* Resume pointer-events on children components */
  pointer-events: initial;
  transition: color 0.2s, opacity 0.2s;
}
.vue__time-picker .controls > *:hover {
  color: #797979;
}
.vue__time-picker .controls > *:focus,
.vue__time-picker .controls > *:active {
  outline: 0;
}
.vue__time-picker .controls .char {
  font-size: 1.1em;
  line-height: 100%;
  /* Vertical align fixes for webkit browsers only */
  -webkit-margin-before: -0.15em;
}
.vue__time-picker .custom-icon {
  z-index: 2;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 1.8em;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  /* pass down mouse events to the <input> underneath */
  pointer-events: none;
}
.vue__time-picker .custom-icon img,
.vue__time-picker .custom-icon svg,
.vue__time-picker .controls img,
.vue__time-picker .controls svg {
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  border: 0;
  outline: 0;
  max-width: 1em;
  height: auto;
}
.vue__time-picker .time-picker-overlay {
  z-index: 4;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.vue__time-picker .dropdown {
  position: absolute;
  z-index: 5;
  /* top: calc(2.2em + 2px); */
  left: -25px;
  background: #fff;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.15);
  width: 10em;
  height: 10em;
  font-weight: normal;
}
.vue__time-picker .dropdown.drop-up {
  top: auto;
  bottom: calc(2.2em + 1px);
}
.vue__time-picker .dropdown .select-list {
  width: 10em;
  height: 10em;
  overflow: hidden;
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;
  justify-content: space-between;
}
.vue__time-picker .dropdown .select-list:focus,
.vue__time-picker .dropdown .select-list:active {
  outline: 0;
}
.vue__time-picker .dropdown ul {
  padding: 0;
  margin: 0;
  list-style: none;
  outline: 0;
  flex: 1 1 0.00001px;
  overflow-x: hidden;
  overflow-y: auto;
}
.vue__time-picker .dropdown ul.minutes,
.vue__time-picker .dropdown ul.seconds,
.vue__time-picker .dropdown ul.apms {
  border-left: 1px solid #fff;
}
.vue__time-picker .dropdown ul li {
  list-style: none;
  text-align: center;
  padding: 0.3em 0;
  color: #161616;
}
.vue__time-picker .dropdown ul li:not(.hint):not([disabled]):hover,
.vue__time-picker .dropdown ul li:not(.hint):not([disabled]):focus {
  background: rgba(0, 0, 0, 0.08);
  color: #161616;
  cursor: pointer;
}
.vue__time-picker .dropdown ul li:not([disabled]).active,
.vue__time-picker .dropdown ul li:not([disabled]).active:hover,
.vue__time-picker .dropdown ul li:not([disabled]).active:focus {
  background: #41b883;
  color: #fff;
}
.vue__time-picker .dropdown ul li[disabled],
.vue__time-picker .dropdown ul li[disabled]:hover {
  background: transparent;
  opacity: 0.3;
  cursor: not-allowed;
}
.vue__time-picker .dropdown .hint {
  color: #a5a5a5;
  cursor: default;
  font-size: 0.8em;
}
</style>
